import type { CustomRole } from '../internal/types';

import { filterAllowStatements } from './filterAllowStatements';
import { getAllRoleStatements } from './getAllRoleStatements';

export function roleAllowsViewProject(role: CustomRole) {
  const allStatements = getAllRoleStatements(role);
  const allAllowStatements = filterAllowStatements(allStatements);
  return allAllowStatements.some(
    (statement) =>
      statement.actions?.includes('viewProject') ||
      (statement.resources?.some((r) => r.includes('proj')) && statement.actions?.includes('*')),
  );
}
